
	import { defineComponent, PropType } from 'vue';

	import { CustodyResidentialService } from '@/Services/custody-residential-service';
	import { ValidationHelper } from '@/Services/Helper/validation-helper';
	import { DateHelper } from '@/Services/Helper/date-helper';

	import { ICustodyResidential } from '@/Models/ICustodyResidential';
	import { IDataTableHeader } from '@/Models/IDataTableHeader';
	import { MasterLookupWrapper } from '@/Models/Lookup/MasterLookupWrapper';

	import LoadingSpinner from '@/ChildrenComponents/LoadingSpinner.vue';
	import CustodyResidentialDialog from '@/ChildrenComponents/Phase/PhaseCustodyResidentialDialog.vue';
    import { CustodyResidentialTypes } from '@/Enums/CustodyResidentialTypes';

	export default defineComponent({
		name: 'phase-custody-residential',
		components: { LoadingSpinner, CustodyResidentialDialog },
		props: {
			lookups: {
				type: Object as PropType<MasterLookupWrapper>,
				required: true
			},
			phaseId: {
				type: Number,
				required: true
			},
			isSaveAllowed: {
				type: Boolean,
				required: true
			},
			isDeleteAllowed: {
				type: Boolean,
				required: true
			},
		},
		created() {
			this.loadData();
		},
		emits: [
			"onLoad",
		],
		data() {
			return {
				isLoading: true,
				isSaving: false,
				showModal: false,
				items: [] as ICustodyResidential[],
				editingItem: {} as ICustodyResidential,
				requiredRules: ValidationHelper.requiredRules,
				headers: [
					{ title: "Type", key: "custodyOrResidential", sortable: true, align: "start" },
					{ title: "Start Date", key: "startDate", sortable: true, align: "start" },
					{ title: "End Date", key: "endDate", sortable: true, align: "start" },
                    { title: "Target End Date", key: "targetEndDate", sortable: true, align: "start" },
					{ title: "Notes", key: "notes", sortable: true, align: "start" },
                    { title: "Location", key: "location", sortable: true, align: "start" },
					{ title: "Edit", key: "actions", sortable: false },
				] as IDataTableHeader[],
			}
		},
		methods: {
			setBlankItem() {
				const newItem = {
					custodyResidentialId: 0,
					phaseId: this.phaseId,
				} as ICustodyResidential;
				this.editingItem = newItem;
			},
			loadData() {
				this.isLoading = true;
				CustodyResidentialService.getByPhaseId(this.phaseId)
					.then(items => this.items = items)
					.finally(() => {
						this.$emit("onLoad", this.items.map(i => ({
							...i,
							typeName: this.formatType(i.custodyOrResidential)
						})));
						this.isLoading = false;
					});
			},
			formatDate(date: Date): string {
				return DateHelper.formatDateUtc(date, "MM/dd/yyyy");
			},
            formatType(type: CustodyResidentialTypes): string {
                return type.toString().replace("In", "In ");
            },
			addRow() {
				this.setBlankItem();
				this.showModal = true;
			},
			editRow(item: ICustodyResidential) {
				this.editingItem = item;
				this.showModal = true;
			},
			deleteRow(id: number) {
				if (confirm("Are you sure you want to delete?")) {
					CustodyResidentialService.delete(id).then(() => this.items = this.items.filter(x => x.custodyResidentialId != id));
				}
			},
			onSave(item: ICustodyResidential, startNew: boolean) {
				let index = this.items.findIndex(x => x.custodyResidentialId == item.custodyResidentialId);
				if (index > -1) {
					this.items[index] = item;
				}
				else {
					this.items.push(item);
				}
				if (startNew) {
					this.setBlankItem();
				}
				else {
					this.showModal = false;
				}
			},
		},
		watch: {
			phaseId() {
				this.loadData();
			},
			items: {
				deep: true,
				handler() {
					// during the loading workflow, it manages emission itself, this is for updates
					if (!this.isLoading) {
						this.$emit("onLoad", this.items.map(i => ({
							...i,
							typeName: this.formatType(i.custodyOrResidential)
						})));
					}
				}
			},
		},
	}); 
